import { ClassificationType, type ClassificationBasicItem } from '@/types/classification';

export interface ApiClassificationHelperSectionRequest {
    type: ClassificationType;
}

export interface ApiClassificationHelperSectionResponse {
    response: ClassificationBasicItem[];
}

export const ClassificationHelperSection = Symbol.for('ClassificationHelperSection');

export interface ClassificationHelperSection {
    classificationHelperSection(data: ApiClassificationHelperSectionRequest): Promise<ApiClassificationHelperSectionResponse>;
}
